import { NavigationItem, type AppliedAgencyProfileFieldsFragment } from '~/api/graphql';
import { useOptionalCurrentAgencyUser } from './current-user';

/**
 * The profile governing the signed-in user, or null when their agency has none
 * that reaches them. It rides along on the root loader's agency user, so
 * reading it costs nothing and never races the deferred loader.
 */
export const useAppliedAgencyProfile = (): AppliedAgencyProfileFieldsFragment | null =>
  useOptionalCurrentAgencyUser()?.profile ?? null;

/**
 * Tests whether a sidebar entry belongs in this user's navigation. With no
 * profile applied every entry is shown, which is what an agency that has not
 * authored one expects.
 */
export const showsNavigationItem = (
  profile: AppliedAgencyProfileFieldsFragment | null,
  item: NavigationItem
): boolean => !profile || profile.configuration.navigation.includes(item);
